export const CREATE_DIAGNOSTIC_DEVICE_OPEN_MODAL = "CREATE_DIAGNOSTIC_DEVICE_OPEN_MODAL";
export const CREATE_DIAGNOSTIC_DEVICE_CLOSE_MODAL = "CREATE_DIAGNOSTIC_DEVICE_CLOSE_MODAL";

export const CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST = "CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST";
export const CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_RESULT = "CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_RESULT";

export const CREATE_DIAGNOSTIC_DEVICE_REQUEST = "CREATE_DIAGNOSTIC_DEVICE_REQUEST";
export const CREATE_DIAGNOSTIC_DEVICE_RESULT = "CREATE_DIAGNOSTIC_DEVICE_RESULT";

export const CREATE_DIAGNOSTIC_DEVICE_SET_DEVICES = "CREATE_DIAGNOSTIC_DEVICE_SET_DEVICES";

export const CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST = "CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST";
export const CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_RESULT = "CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_RESULT";

export const CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST = "CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST";
export const CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_RESULT = "CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_RESULT";